export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {Notification} from 'kpc';
import {bind} from 'kpc';

export default class extends Component {
    static template = template;
    
    @bind
    showNotificationIcon() {
        Notification.notice({
            title: '自定义图标',
            content: 'hello, kc',
            icon: 'k-icon-notification-fill'
        });
    }

    @bind
    showTimeIcon() {
        Notification.notice({
            title: '自定义图标',
            content: 'hello, kc',
            icon: 'k-icon-time'
        });
    }
}